module.exports = __webpack_public_path__ + "img/icon_fast.0750e30e.png";